$(function () {
    let _csLinks = $('.cs-links');
    let _storeLocale = Shopify.locale;
    let _csWidgets = [];

    if (_csLinks) {
        /* GET UTM from URL or Session Storage for CS button generation */
        getUtmParameter("utm_medium, utm_source, utm_campaign, utm_content");

        /* ChannelSight Button Generation */
        let csLoading = false;

        function csLoadingComplete() {
            return csLoading;
        }

        let _cookie = getCookie("country").toLowerCase();

        //Loops through all .cs-links and gets the sku
        function rerunCsLinks() {
            // for all products
            _csLinks = $('.cs-links');
            _csWidgets = [];

            _csLinks.each(function (i, obj) {
                let _this = $(obj);

                //skip .cs-links that ChannelSight has already processed (a button has already been appended)
                if (_this.children("button").length) {
                    return;
                }

                let _sku = _this.data("product-sku");
                let _rawSpecialAsset = _this.data("special-asset-id");
                let _channelsightSpecialAsset = _rawSpecialAsset ? String(_rawSpecialAsset) : "";
                let _csWidgetAsset = "5719"; //default for US country cookie viewing the English site

                //special asset only applies to the US cookie on the English site; anything else
                //falls through to the standard country/locale mapping below
                if (_channelsightSpecialAsset === "7664" && _cookie === "us" && _storeLocale === "en") { //used on the ewing-golf LP
                    _csWidgetAsset = _channelsightSpecialAsset;
                } else {
                    //decides which ChannelSight asset to choose based on country cookie and store locale
                    if (_cookie === "us") {
                        if (_storeLocale === "es") { //for US country cookie viewing the Spanish site
                            _csWidgetAsset = "5900";
                        } else if (_storeLocale === "fr") { //for US country cookie viewing the French site
                            _csWidgetAsset = "5722";
                        }
                    } else if (_cookie === "ca") {
                        if (_storeLocale === "en") { //for CA country cookie viewing the English site
                            _csWidgetAsset = "5734";
                        } else if (_storeLocale === "es") { //for CA country cookie viewing the Spanish site
                            _csWidgetAsset = "5901";
                        } else if (_storeLocale === "fr") { //for CA country cookie viewing the French site
                            _csWidgetAsset = "5811";
                        }
                    } else {
                        //Spanish Site
                        if (_storeLocale === "es") { //for ES Country, viewing the Spanish site
                            _csWidgetAsset = "5900";
                        } else if (_storeLocale === "fr") { //for ES country cookie viewing the French site
                            _csWidgetAsset = "5722";
                        }
                    }
                }

                // Check if the asset already exists in the csWidgets array
                let existingEntry = _csWidgets.find(widget => widget.asset === _csWidgetAsset);

                if (existingEntry) {
                    // Append the SKU to the existing entry if it's not already present
                    if (!existingEntry.sku.split(',').includes(_sku)) {
                        existingEntry.sku += `,${_sku}`;
                    }
                } else {
                    // Create a new entry if the asset doesn't exist
                    _csWidgets.push({
                        asset: _csWidgetAsset,
                        sku: _sku
                    });
                }
            });

            //process api call once all .cs-links have been evaluated
            if (_csWidgets.length) {
                callCSApi();
            }

            //calls channelsight api to decide whether or not to add the Where To Buy widget - The widget called is dynamic based on csWidgetAsset and all the visible skus combined
            function callCSApi() {
                $(_csWidgets).each(function (csWidgetI, csWidgetObj) {
                    if (csWidgetObj.asset !== "") {
                        requestCsFeed(csWidgetObj, 0);
                    }
                });
            }

            //each asset gets its own retry count so a timeout on one asset doesn't consume another asset's retry
            function requestCsFeed(csWidgetObj, retries) {
                $.ajax({
                    url: "https://api.channelsight.com/api/2.42/feed?key=f3c8a136-7dfc-4e26-8f18-0e6685a5418e&assetId=" + csWidgetObj.asset + "&pid=" + csWidgetObj.sku,
                    type: 'GET',
                    cache: false,
                    timeout: 50000
                })
                   .done(function (data) {
                       let productFound = false;

                       if (!$.isEmptyObject(data)) {
                           $(data).each(function (i, data) {
                               //asset 7664 (ewing-golf LP) always shows the button, even with no retailers
                               if (!$.isEmptyObject(data["RetailerProducts"]) || csWidgetObj.asset === "7664") {
                                   let _productId = data.ProductId;
                                   let _csContainer = $('.cs-links[data-product-sku="' + _productId + '"]');

                                   //Loop through all widgets and get the widget-type attribute (sometimes on a single page there are multiple of the same div with the same sku)
                                   //adds in the Where To Buy Button
                                   _csContainer.each(function (index, obj) {
                                       let _obj = $(obj);

                                       //skip containers ChannelSight has already processed (a button has already been appended)
                                       if (_obj.children("button").length) {
                                           return;
                                       }

                                       let _widgetType = _obj.attr("widget-type");
                                       let _widgetCopy = _obj.attr("widget-copy");

                                       if (!productFound) {
                                           let _widgetSource = _obj.attr("widget-wtbsource");
                                           _widgetSource = _widgetSource ? _widgetSource : "lp";
                                           _widgetSource = _widgetSource.toUpperCase();

                                           gtmParams = gtmParams ? gtmParams + " data-wtbsource=" + _widgetSource + "" : "data-wtbsource=" + _widgetSource + "";

                                           productFound = true;
                                       }

                                       if (_widgetType === "button") { //common button
                                           //add primary WTB button
                                           _obj.html('<button class="cswidget ego-c-btn ego-c-btn-wtb wheretobuy" data-asset-id="' + csWidgetObj.asset + '" data-product-sku="' + _productId + '" ' + gtmParams + '>' + _widgetCopy + '</button>');
                                       } else if (_widgetType === "link") { //common link
                                           //add primary WTB button
                                           _obj.html('<button class="cswidget btn-secondary wheretobuy" data-asset-id="' + csWidgetObj.asset + '" data-product-sku="' + _productId + '" ' + gtmParams + '>' + _widgetCopy + '</button>');
                                       }
                                   });
                               }
                           });
                       }

                       reInitializeCS(false);
                   })
                   .fail(function (error) {
                       if ((_cookie === "us" || _cookie === "ca") && localStorage.getItem("cserror") !== "true") {
                           localStorage.setItem("cserror", "true"); //set variable to prevent spamming of email for a single user.

                           if (error.statusText === 'timeout') {
                               if (retries < 1) {
                                   requestCsFeed(csWidgetObj, retries + 1);
                               } else {
                                   // console.log("timeout email sent");
                                   $.get("https://ipinfo.io/?token=feb214e2392652", function (response) {
                                       errorNotify(error, "Timeout - IP:" + response.ip);
                                   }, "json")
                               }
                           } else {
                               // console.log("error email sent");
                               $.get("https://ipinfo.io/?token=feb214e2392652", function (response) {
                                   errorNotify(error, "Not Timeout - IP:" + response.ip);
                               }, "json")
                           }
                       }
                   });
            }
        }

        //Watches .cswidget buttons for the "data-instanceid" attribute, which ChannelSight's
        //loader script adds once a widget finishes initializing. Once that happens, we remove
        //the cswidget class so the loader doesn't keep re-processing an already-initialized button.
        function watchCsWidgetInstances() {
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === "attributes" && mutation.attributeName === "data-instanceid") {
                        let _target = $(mutation.target);

                        if (_target.hasClass("cswidget") && _target.attr("data-instanceid") && !_target.hasClass("cswidget-offline")) {
                            _target.removeClass("cswidget");
                        }
                    }
                });
            });

            observer.observe(document.body, {
                attributes: true,
                attributeFilter: ["data-instanceid"],
                subtree: true
            });
        }

        //This is needed to "load" the widgets once added to the page dynamically above
        function reInitializeCS(_rerunLinks) {
            $("#cswidgetloaderjs, #cswidgetjs").remove();
            if (!document.getElementById('cswidgetloaderjs')) {
                var script = document.createElement('script');
                script.src = 'https://cdn.channelsight.com/widget/scripts/cswidget.loader.js';
                script.id = "cswidgetloaderjs";
                document.head.appendChild(script);

                if (_rerunLinks) {
                    rerunCsLinks();
                }
            }
            csLoading = true;
        }

        $(document).ready(function () {
            watchCsWidgetInstances();

            //processes CSlinks on page load but wait until country cookie is set.
            const processCSLinksInterval = setInterval(() => {
                if (
                   typeof processCSLinks !== "undefined" &&
                   processCSLinks === true
                ) {
                    rerunCsLinks();
                    clearInterval(processCSLinksInterval);
                }
            }, 100);
        });

        window.reInitializeCS = reInitializeCS;
        window.csLoadingComplete = csLoadingComplete;
    }
});